/**
 * App Component
 * Main app with routing
 */

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import HomePage from './pages/HomePage';
import RegisterPage from './pages/RegisterPage';
import LoginPage from './pages/LoginPage';
import ProfilePage from './pages/ProfilePage';
import ProfileEditPage from './pages/ProfileEditPage';
import FindPage from './pages/FindPage';
import PublicProfilePage from './pages/PublicProfilePage';
import CreateEventPage from './pages/CreateEventPage';
import EditEventPage from './pages/EditEventPage';
import EventsPage from './pages/EventsPage';
import EventDetailPage from './pages/EventDetailPage';
import MyGoingEventsPage from './pages/MyGoingEventsPage';
import CreateOpportunityPage from './pages/CreateOpportunityPage';
import EditOpportunityPage from './pages/EditOpportunityPage';
import OpportunitiesPage from './pages/OpportunitiesPage';
import OpportunityDetailPage from './pages/OpportunityDetailPage';
import CreateArticlePage from './pages/CreateArticlePage';
import ArticlesPage from './pages/ArticlesPage';
import ArticleDetailPage from './pages/ArticleDetailPage';
import EditArticlePage from './pages/EditArticlePage';
import CollaborationRequestsPage from './pages/CollaborationRequestsPage';
import NewsPage from './pages/NewsPage';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
	  <Route path="/articles" element={<Navigate to="/news?tab=articles" replace />} />
	  <Route path="/events" element={<Navigate to="/news?tab=events" replace />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/profile/edit" element={<ProfileEditPage />} />
          <Route path="/find" element={<FindPage />} />
          <Route path="/users/:id" element={<PublicProfilePage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/events/create" element={<CreateEventPage />} />
          <Route path="/events/going" element={<MyGoingEventsPage />} />
          <Route path="/events/:id" element={<EventDetailPage />} />
          <Route path="/events/:id/edit" element={<EditEventPage />} />
          <Route path="/opportunities" element={<OpportunitiesPage />} />
          <Route path="/opportunities/create" element={<CreateOpportunityPage />} />
          <Route path="/opportunities/:id" element={<OpportunityDetailPage />} />
          <Route path="/opportunities/:id/edit" element={<EditOpportunityPage />} />
          <Route path="/articles" element={<ArticlesPage />} />
          <Route path="/articles/create" element={<CreateArticlePage />} />
          <Route path="/articles/:id" element={<ArticleDetailPage />} />
          <Route path="/articles/:id/edit" element={<EditArticlePage />} />
          <Route path="/collaborations/requests" element={<CollaborationRequestsPage />} />
          <Route path="/news" element={<NewsPage />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
